export default {
  'app.pwa.offline': 'Είστε  εκτός σύνδεσης',
  'app.pwa.serviceworker.updated': 'Δεν υπάρχουν νέα περιεχόμενα διαθέσιμα',
  'app.pwa.serviceworker.updated.hint':
    'Παρακαλώ πιέστε το πλήκτρο "Ανανέωση" για φόρτωση της τρέχουσας σελίδας',
  'app.pwa.serviceworker.updated.ok': 'Ανανέωση',
};
